import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsWebhooksBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Webhooks</div>
          <div className="text">
            By setting up webhooks, your server will be notified of Canny events as they happen. For
            example, if a user creates a new post, we would send a request to your server to let you
            know.
          </div>
          <div className="text">
            You can set up webhooks for your account in{' '}
            <div className="emphasize">
              Your&nbsp;Subdomain&nbsp;&gt;&nbsp;Settings&nbsp;&gt;&nbsp;API
            </div>
            .
          </div>
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
